import { lines, players } from '../data';

export default {
  roundID: 0,
  result: null,
  isProcess: false,
  gameStatus: 0,
  limits: {
    min: 0,
    max: 0,
    win: 0,
  },
  gameSettings: {
    linesCount: lines[0],
    playersCount: players[0],
    amount: 0,
    isAutoPick: false,
    autoPickData: '',
  },
  temp_pick: '',
  wrong_picks: [],
  lives: players[0],
  placedAmount: 0,
  rtp: 1,
  coeffs: {
    2: {
      1: [],
      2: [],
      3: [],
    },
    3: {
      1: [],
      2: [],
      3: [],
    },
  }
}